import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Image from 'next/legacy/image';
import styled from 'styled-components';
import { useState } from 'react';
import { motion } from 'framer-motion';
import { Title, Interactive } from '@yoweb/ui/components/typography';
import { Box } from '@yoweb/ui/components/Box';
import { Grid } from '@yoweb/ui/components/Grid';
import { trackEvent } from '@yoweb/utils/analytics/mixpanel';
import { getColor } from '@yoweb/ui/styles/utils/theme';
import { ArrowRightIcon } from '@yoweb/ui/components/Icon';
import { Divider } from '@yoweb/ui/components/Divider';
import { useTasks } from '@poplar/contexts/TaskContext/TaskProvider';
import { Flex } from '@yoweb/ui/components/Flex';
import { TodoEntryPoint, TodoType } from '@yoweb/types/external-events';
import { useTranslation } from '@yoweb/next-i18next';
import { theme } from '@yoweb/ui/styles';
import { pxToRem } from '@yoweb/ui/styles/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Category = function Category(_ref) {
  var _category$topListCard2, _category$topListCard3;

  var category = _ref.category,
      columnSize = _ref.columnSize;

  var _useTranslation = useTranslation('home'),
      t = _useTranslation.t;

  var _useTasks = useTasks(),
      _useTasks$actions = _useTasks.actions,
      openTaskIntakeModalForTemplateId = _useTasks$actions.openTaskIntakeModalForTemplateId,
      openTaskIntakeModalForCategoryId = _useTasks$actions.openTaskIntakeModalForCategoryId;

  var _useState = useState(false),
      hiddenTextVisible = _useState[0],
      setHiddenTextVisible = _useState[1];

  var commonAnimationProps = {
    duration: (hiddenTextVisible ? theme.transitionDuration.interaction : 200) / 1000,
    ease: theme.transitionPoints.easeInOut
  };
  var subCategoryFirstHalf = category.listCardsList.slice(0, columnSize);
  var subCategorySecondHalf = category.listCardsList.slice(columnSize);

  var onSubCategoryClick = function onSubCategoryClick(subCategory) {
    openTaskIntakeModalForTemplateId(subCategory.taskTemplateId, subCategory.skipPdp);
    trackEvent({
      todoStart: {
        title: subCategory.name,
        entryPoint: TodoEntryPoint.TODO_ENTRY_POINT_HOME_SUBCATEGORY,
        type: TodoType.TODO_TYPE_B
      }
    });
  };

  return /*#__PURE__*/_jsxs(CategoryContainer, {
    p: "normal2",
    backgroundColor: "base000",
    radii: "small",
    children: [/*#__PURE__*/_jsxs(CategoryHeader, {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      "data-testid": "category-header",
      onClick: function onClick() {
        var _category$topListCard;

        if ((_category$topListCard = category.topListCard) !== null && _category$topListCard !== void 0 && _category$topListCard.id) {
          openTaskIntakeModalForCategoryId(category.topListCard.id);
          trackEvent({
            todoCategoryView: {
              categoryTitle: category.topListCard.name
            }
          });
        }
      },
      onMouseEnter: function onMouseEnter() {
        return setHiddenTextVisible(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setHiddenTextVisible(false);
      },
      children: [((_category$topListCard2 = category.topListCard) === null || _category$topListCard2 === void 0 ? void 0 : _category$topListCard2.iconImageUrl) && /*#__PURE__*/_jsx(Box, {
        p: "small3",
        backgroundColor: "sand",
        radii: "small",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/_jsx(Image, {
          src: category.topListCard.iconImageUrl,
          width: 32,
          height: 32
        })
      }), /*#__PURE__*/_jsx(Box, {
        ml: "normal1",
        mr: "small3",
        children: /*#__PURE__*/_jsx(CategoryTitle, {
          children: (_category$topListCard3 = category.topListCard) === null || _category$topListCard3 === void 0 ? void 0 : _category$topListCard3.name
        })
      }), /*#__PURE__*/_jsx(motion.div, {
        initial: {
          opacity: 0,
          width: 0,
          marginLeft: 0
        },
        animate: hiddenTextVisible ? {
          opacity: 1,
          width: 'auto',
          marginLeft: theme.space.small3
        } : {
          opacity: 0,
          width: 0,
          marginLeft: 0
        },
        transition: {
          opacity: _objectSpread(_objectSpread({}, commonAnimationProps), {}, {
            delay: hiddenTextVisible ? 0.2 : 0
          }),
          width: _objectSpread(_objectSpread({}, commonAnimationProps), {}, {
            delay: hiddenTextVisible ? 0 : 0.1
          }),
          marginLeft: _objectSpread(_objectSpread({}, commonAnimationProps), {}, {
            delay: hiddenTextVisible ? 0.2 : 0.1
          })
        },
        children: /*#__PURE__*/_jsx(Box, {
          mr: "small2",
          children: /*#__PURE__*/_jsx(Interactive, {
            size: "lg",
            whiteSpace: "nowrap",
            textDecoration: "underline",
            children: t('view-all')
          })
        })
      }), /*#__PURE__*/_jsx(ArrowRightIcon, {
        size: 24
      })]
    }), /*#__PURE__*/_jsx(DividerWithMargin, {
      variant: "sandMedium",
      size: "ms"
    }), /*#__PURE__*/_jsxs(Grid, {
      columns: {
        _: '1fr',
        md: '1fr 1fr'
      },
      columnGap: {
        _: 'normal4',
        xl: 'medium2'
      },
      rowGap: "small4",
      children: [/*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        rowGap: "small4",
        children: subCategoryFirstHalf.map(function (subCategory, i) {
          return /*#__PURE__*/_jsx(SubCategoryInteractive, {
            size: "lg",
            weight: "semibold",
            onClick: function onClick() {
              return onSubCategoryClick(subCategory);
            },
            "data-testid": "sub-category",
            children: subCategory.name
          }, "left-col-".concat(i));
        })
      }), /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        rowGap: "small4",
        children: subCategorySecondHalf.map(function (subCategory, i) {
          return /*#__PURE__*/_jsx(SubCategoryInteractive, {
            size: "lg",
            weight: "semibold",
            onClick: function onClick() {
              return onSubCategoryClick(subCategory);
            },
            "data-testid": "sub-category",
            children: subCategory.name
          }, "right-col-".concat(i));
        })
      })]
    })]
  });
};

var CategoryRow = function CategoryRow(_ref2) {
  var _secondCategory$listC, _secondCategory$listC2;

  var firstCategory = _ref2.firstCategory,
      secondCategory = _ref2.secondCategory;
  // Set column size to half the size of the larger list
  var columnSize = Math.ceil(Math.max(firstCategory.listCardsList.length, (_secondCategory$listC = secondCategory === null || secondCategory === void 0 ? void 0 : (_secondCategory$listC2 = secondCategory.listCardsList) === null || _secondCategory$listC2 === void 0 ? void 0 : _secondCategory$listC2.length) !== null && _secondCategory$listC !== void 0 ? _secondCategory$listC : 0) / 2);
  return /*#__PURE__*/_jsxs(Grid, {
    columns: {
      _: '1fr',
      lg: '1fr 1fr'
    },
    children: [firstCategory.listCardsList.length > 0 ? /*#__PURE__*/_jsx(Category, {
      category: firstCategory,
      columnSize: columnSize
    }) : null, secondCategory && secondCategory.listCardsList.length > 0 ? /*#__PURE__*/_jsx(Category, {
      category: secondCategory,
      columnSize: columnSize
    }) : null]
  });
};

var CategoryContainer = styled(Box).withConfig({
  componentId: "sc-140705f-0"
})(["&&{border:1.5px solid ", ";}"], getColor('sand'));
var CategoryHeader = styled(Box).withConfig({
  componentId: "sc-140705f-1"
})(["&&{width:fit-content;cursor:pointer;}"]);
var SubCategoryInteractive = styled(Interactive).withConfig({
  componentId: "sc-140705f-2"
})(["&&{cursor:pointer;&:hover{text-decoration:underline;}}"]);
var CategoryTitle = styled(Title).withConfig({
  componentId: "sc-140705f-3"
})(["&&{font-size:", ";}"], pxToRem(22));
var DividerWithMargin = styled(Divider).withConfig({
  componentId: "sc-140705f-4"
})(["&&{margin:", " 0 ", " 0;}"], pxToRem(20), pxToRem(20));
export default CategoryRow;